import {
  createClient as _createClient,
  getRepositoryName,
} from '@prismicio/client'
import { enableAutoPreviews } from '@prismicio/next'

import sm from './sm.json'

export { linkResolver } from './linkResolver'

/**
 * The project's Prismic repository name.
 */
export const repositoryName = getRepositoryName(sm.apiEndpoint)

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config {prismicNext.CreateClientConfig} - A configuration object to
 */
export const createClient = (config = {}) => {
  const client = _createClient(sm.apiEndpoint)

  enableAutoPreviews({
    client,
    // @ts-ignore
    previewData: config.previewData,
    // @ts-ignore
    req: config,
  })

  return client
}
